const namespaced = true

const state = {}

const actions = {
    async getAllMediasPerSection({dispatch}, section) {
        let data = await dispatch('database/getMultiple', ['medias'], {root: true})
        let mediasToReturn = data['medias'].filter(media => media.section == section);
        return mediasToReturn
    },
}
const mutations = {}
const getters = {}

export const medias = {
    namespaced,
    state,
    getters,
    mutations,
    actions
}
